/**
 * AYA CUSTOM PRICING — CART + CHECKOUT
 *
 * Custom-priced product:
 * Product -> AYA pricing -> Shopify Ajax Cart -> /cart
 * -> Checkout -> Cloudflare Draft Order -> secure Shopify checkout.
 */
(function () {
  'use strict';

  const API_BASE = 'https://aya-shopify-pricing-api.serifinejewelry.workers.dev';
  const CUSTOM_PRICE_KEY = '_custom_price';
  const CUSTOM_FLAG_KEY = '_aya_custom_pricing';

  function num(value, fallback) {
    const n = parseFloat(value);
    return Number.isFinite(n) ? n : (fallback || 0);
  }

  function json(id) {
    const el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent || '{}'); } catch (e) { return null; }
  }

  function cartRoot() {
    return window.Shopify?.routes?.root || '/';
  }

  async function postJson(path, body) {
    let response;
    try {
      response = await fetch(API_BASE + path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
    } catch (networkError) {
      throw new Error('Could not connect to AYA server. ' + (networkError?.message || 'Network error.'));
    }

    let rawText = '';
    let data = null;
    try {
      rawText = await response.text();
      data = rawText ? JSON.parse(rawText) : null;
    } catch (e) {
      throw new Error('AYA server returned HTTP ' + response.status + ' with an invalid response: ' + (rawText || 'empty response'));
    }

    console.log('[AYA Pricing API]', path, { status: response.status, request: body, response: data });

    if (!response.ok || data?.ok !== true) {
      let message = data?.error || ('Server returned HTTP ' + response.status);
      if (data?.details) message += '\nDetails: ' + JSON.stringify(data.details);
      if (data?.path) message += '\nPath: ' + data.path;
      throw new Error(message);
    }
    return data;
  }

  function getSelected() {
    const meta = json('shopify-product-metafields');
    const rates = json('shopify-pricing-config');
    if (!meta || !rates) return null;

    const combo = document.querySelector('input[name="metal_combo"]:checked');
    const colorEl = document.querySelector('input[name="color"]:checked') || document.getElementById('HiddenSelectedColor');
    const karatEl = document.querySelector('input[name="karat"]:checked') || document.querySelector('select[name="karat"]') || document.getElementById('HiddenSelectedKarat');
    const caratEl = document.querySelector('input[name="carat"]:checked') || document.querySelector('select[name="carat"]');

    let metalType = (meta.metal_type || 'gold').toLowerCase();
    let karat = karatEl?.value || '14K';
    let metalColor = colorEl?.value || 'Yellow';

    if (combo) {
      metalType = (combo.getAttribute('data-metal-type') || 'gold').toLowerCase();
      karat = combo.getAttribute('data-karat') || karat;
      metalColor = combo.getAttribute('data-color') || metalColor;
    }

    const upgradeEnabled =
      meta.diamond_upgrade_enabled === true ||
      meta.diamond_upgrade_enabled === 'true' ||
      meta.diamond_upgrade_enabled === 'TRUE';

    const centerCarat = upgradeEnabled ? num(caratEl?.value, 0) : num(meta.base_carat, 0);

    let metalWeight = num(meta.net_metal_weight, 0);
    if (karat === '10K' && num(meta.metal_weight_10k) > 0) metalWeight = num(meta.metal_weight_10k);
    if (karat === '14K' && num(meta.metal_weight_14k) > 0) metalWeight = num(meta.metal_weight_14k);
    if (karat === '18K' && num(meta.metal_weight_18k) > 0) metalWeight = num(meta.metal_weight_18k);

    return {
      meta,
      payload: {
        metalType,
        karat,
        metalColor,
        metalWeight,
        metalWeight10k: num(meta.metal_weight_10k),
        metalWeight14k: num(meta.metal_weight_14k),
        metalWeight18k: num(meta.metal_weight_18k),
        centerCarat,
        baseCarat: num(
          meta.base_carat ||
          meta.diamond_carat
        ),
        diamondUpgradeEnabled:
          meta.diamond_upgrade_enabled === true ||
          meta.diamond_upgrade_enabled === 'true' ||
          meta.diamond_upgrade_enabled === 'TRUE',
        sideDiamondCarat: num(meta.side_diamonds_total_weight || meta.side_diamond_carat),
        goldRate10k: num(rates.aya_10k_rate),
        goldRate14k: num(rates.aya_14k_rate),
        goldRate18k: num(rates.aya_18k_rate),
        goldRate: num(rates.aya_14k_rate),

        /*
         * Current Shopify ProductVariant selected on the PDP.
         * Cloudflare can use this to resolve the exact variation.
         */
        variantId:
          document.getElementById(
            'ProductSelectedVariantId'
          )?.value ||
          document.querySelector(
            'form[action="/cart/add"] input[name="id"]'
          )?.value ||
          '',
        goldRate10k: num(rates.aya_10k_rate),
        goldRate14k: num(rates.aya_14k_rate),
        goldRate18k: num(rates.aya_18k_rate),

        /* Diamond Origins */
        diamondOrigins: Array.isArray(meta.diamond_origins)
          ? meta.diamond_origins
          : [],

        diamondOrigin:
          document.querySelector('.aya-reference-gemstone .diamond-origin-selector:checked')?.value ||
          (
            Array.isArray(meta.diamond_origins) &&
            meta.diamond_origins.includes("Lab Grown")
              ? "Lab Grown"
              : (
                  Array.isArray(meta.diamond_origins) &&
                  meta.diamond_origins[0]
                ) ||
                "Lab Grown"
          ),

        naturalDiamondUpgradeRate:
          num(
            rates.natural_diamond_upgrade_rate_per_carat
          ),

        labGrownDiamondUpgradeRate:
          num(
            rates.lab_grown_diamond_upgrade_rate_per_carat
          ),

        naturalDiamondRate:
          num(rates.natural_diamond_rate_per_carat),

        labGrownDiamondRate:
          num(rates.lab_grown_diamond_rate_per_carat),

        moissaniteRate:
          num(rates.moissanite_rate_per_carat),

        makingCharge:
          num(rates.making_charge_per_gram),

        markupMultiplier:
          num(rates.markup_multiplier, 1),

        platinumRate:
          num(rates.platinum_rate),

        silverRate:
          num(rates.silver_rate)
      }
    };
  }

  async function addCustomProductToCart(event, button) {
    const pricing = getSelected();
    if (!pricing || !pricing.meta.has_custom_pricing) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    button.disabled = true;
    const originalText = button.textContent;
    button.textContent = 'Adding...';

    try {
      const pricingResult = await postJson('/api/pricing', pricing.payload);
      const finalPrice = num(pricingResult.price, 0);
      if (finalPrice <= 0) throw new Error('Calculated price is invalid.');

      const form =
        button.closest('form[action="/cart/add"]') ||
        document.querySelector('form[action="/cart/add"]');

      const variantId =
        form?.querySelector('input[name="id"]')?.value ||
        document.getElementById('ProductSelectedVariantId')?.value;

      if (!variantId) throw new Error('Product variant ID was not found.');

      const quantity = Math.max(
        1,
        parseInt(form?.querySelector('input[name="quantity"]')?.value || '1', 10)
      );

      const selectedSize =
        document.getElementById('RingSize')?.value ||
        document.querySelector('select[name="size"]')?.value ||
        '';

      const selectedBraceletSize =
        document.getElementById('BraceletSize')?.value || '';

      const selectedNecklaceLength =
        document.getElementById('NecklaceLength')?.value || '';

      const selectedColor =
        pricing.payload.metalColor ||
        document.getElementById('HiddenSelectedColor')?.value ||
        '';

      const selectedKarat =
        pricing.payload.karat ||
        document.getElementById('HiddenSelectedKarat')?.value ||
        '';

      const selectedCarat =
        pricing.payload.centerCarat || '';

      const anniversary =
        document.getElementById('AnniversaryCheckbox')?.checked ? 'Yes' : 'No';

      const properties = {
        '_custom_price': finalPrice.toFixed(2),
        '_aya_custom_pricing': 'true',
        'Metal Color': selectedColor,
        'Metal Purity': selectedKarat,
        'Center Carat': String(selectedCarat),
        'Diamond Origin':
          pricing.payload.diamondOrigin || 'Lab Grown'
      };

      if (selectedSize) properties['Ring Size'] = String(selectedSize);
      if (selectedBraceletSize) properties['Bracelet Size'] = String(selectedBraceletSize);
      if (selectedNecklaceLength) properties['Necklace Length'] = String(selectedNecklaceLength);

      const cartResponse = await fetch(
        cartRoot() + 'cart/add.js',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: Number(variantId),
              quantity,
              properties
            }]
          })
        }
      );

      const cartText = await cartResponse.text();
      let cartData = null;
      try { cartData = cartText ? JSON.parse(cartText) : null; } catch (e) {}

      if (!cartResponse.ok) {
        throw new Error(
          cartData?.description ||
          cartData?.message ||
          'Could not add product to cart.'
        );
      }

      console.log('[AYA Cart] Custom product added:', cartData);
      window.location.href = cartRoot() + 'cart';

    } catch (error) {
      console.error('[AYA Cart] Add to cart failed:', error);
      alert('AYA Cart Error:\n\n' + (error?.message || 'Could not add product to cart.'));
      button.disabled = false;
      button.textContent = originalText || 'Add to bag';
    }
  }

  function getCustomPrice(item) {
    const properties = item?.properties || {};

    /*
     * Free gift:
     * _free_gift=true + _custom_price=0
     * is a valid custom price of $0.
     */
    const isFreeGift =
      String(properties._free_gift || '') === 'true' ||
      String(properties['Free Gift'] || '').toLowerCase() === 'yes';

    if (isFreeGift) {
      return 0;
    }

    const value =
      properties[CUSTOM_PRICE_KEY];

    const price =
      num(value, 0);

    return price > 0 ? price : null;
  }

  function buildDraftProperties(item) {
    const properties = item?.properties || {};
    const result = {};

    Object.keys(properties).forEach((key) => {
      const value = properties[key];
      if (value === null || value === undefined || String(value).trim() === '') return;

      if (
        key === CUSTOM_PRICE_KEY ||
        key === CUSTOM_FLAG_KEY ||
        key === '_aya_pricing_payload'
      ) return;

      result[key] = String(value);
    });

    return result;
  }

  async function getCart() {
    const response = await fetch(
      cartRoot() + 'cart.js',
      { headers: { 'Accept': 'application/json' } }
    );

    const data = await response.json();
    if (!response.ok) throw new Error('Could not read the Shopify cart.');
    return data;
  }

  function validateTerms() {
    const terms =
      document.getElementById('CartPage-Terms') ||
      document.getElementById('CartDrawer-Terms');

    if (terms && terms.required && !terms.checked) {
      if (typeof terms.reportValidity === 'function') {
        terms.reportValidity();
      } else {
        alert('Please accept the terms before checkout.');
      }
      return false;
    }

    return true;
  }

  async function handleCartCheckout(event, button) {
    if (!validateTerms()) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      return;
    }

    const cart = await getCart();
    if (!cart?.items?.length) return;

    const hasCustomItems =
      cart.items.some((item) => getCustomPrice(item) !== null);

    if (!hasCustomItems) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    button.disabled = true;
    const originalText = button.textContent;
    button.textContent = 'Processing...';

    try {
      const lineItems = cart.items.map((item) => {
        const customPrice = getCustomPrice(item);

        const lineItem = {
          variantId:
            'gid://shopify/ProductVariant/' + item.variant_id,
          quantity:
            Math.max(1, Number(item.quantity) || 1),
          customAttributes:
            Object.entries(buildDraftProperties(item))
              .map(([key, value]) => ({ key, value }))
        };

        if (customPrice !== null) {
          lineItem.price = customPrice;
        }

        /*
         * Free gift is intentionally $0.
         * The Cloudflare Worker will preserve
         * this as a zero-price draft-order line.
         */

        return lineItem;
      });

      console.log('[AYA Checkout] Cart -> Draft Order:', lineItems);

      const draftResult =
        await postJson('/api/draft-order', { lineItems });

      if (!draftResult.invoiceUrl) {
        throw new Error('Shopify checkout URL was not returned.');
      }

      window.location.href = draftResult.invoiceUrl;

    } catch (error) {
      console.error('[AYA Checkout] Failed:', error);
      alert('AYA Checkout Error:\n\n' + (error?.message || 'Could not create checkout.'));
      button.disabled = false;
      button.textContent = originalText || 'Checkout';
    }
  }

  function bindProductButton() {
    const button = document.querySelector('.add-to-bag-btn');
    if (!button || button.dataset.ayaCartBound === 'true') return;

    button.dataset.ayaCartBound = 'true';

    button.addEventListener(
      'click',
      function (event) {
        const meta = json('shopify-product-metafields');
        const custom =
          meta &&
          (
            meta.has_custom_pricing === true ||
            meta.has_custom_pricing === 'true'
          );

        if (!custom) return;
        addCustomProductToCart(event, button);
      },
      true
    );
  }

  function bindCheckoutButtons() {
    const buttons =
      document.querySelectorAll(
        '#checkout, #CartDrawer-Checkout, button[name="checkout"]'
      );

    buttons.forEach((button) => {
      if (button.dataset.ayaCheckoutBound === 'true') return;

      button.dataset.ayaCheckoutBound = 'true';

      button.addEventListener(
        'click',
        async function (event) {
          try {
            await handleCartCheckout(event, button);
          } catch (error) {
            console.error('[AYA Checkout] Cart read failed:', error);
            alert(
              'AYA Checkout Error:\n\n' +
              (error?.message || 'Could not read cart.')
            );
            button.disabled = false;
          }
        },
        true
      );
    });
  }

  function init() {
    bindProductButton();
    bindCheckoutButtons();

    if (!window.__AYA_CART_OBSERVER__) {
      window.__AYA_CART_OBSERVER__ =
        new MutationObserver(function () {
          bindProductButton();
          bindCheckoutButtons();
        });

      window.__AYA_CART_OBSERVER__.observe(
        document.body,
        { childList: true, subtree: true }
      );
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();